import $ from 'jquery';

const homepageHeader = () => {
    const $headerEl = $('.c-site-header');
    const $burgerButton = $('.c-site-header .o-burger-menu');
    let headerOffset = 0;
    let headerHeight = 0;
    let wh = 0;
    let scrollTop = 0;
    let isMobile = true;
    let mobileOpen = false;
    let isHomepage = $('body').hasClass('homepage');

    // Project details page
    let mainContentOffset = 0;
    let isTransparentHeader = $('.body-transparent-header').length > 0;

    //    ======================================================================  //
    //    Functions
    //    ======================================================================  //

    /**
     * @function `init`
     */
    window.$ = $;
    function init () {
        $burgerButton.on('click', onBurgerClick);
        // Add transition
        $('.c-site-header__links').addClass('has-transition');
        onResize();
    }

    // When user click on the burger button
    function onBurgerClick () {
        // Open or close the submenu
        $headerEl.toggleClass('is-open');
        mobileOpen = !mobileOpen;
    }

    // When user resizes its window
    function onResize () {
        // Get the height of the header
        headerHeight = $headerEl.outerHeight();
        // Get window height
        wh = $(window).height();
        headerOffset = wh - headerHeight;
        // Check if we are on mobile or not
        if (window.matchMedia('only screen and (min-width: 700px)').matches) {
            isMobile = false;
            onScroll();
        } else {
            isMobile = true;
            $headerEl.removeClass('fixed');
        }

        if (isTransparentHeader) {
            mainContentOffset = $('.c-cover + .o-roll').offset().top;
        }

        // On the homepage, apply a fixed margin-top & height for the main & cover
        if (isHomepage) {
            if (isMobile) {
                $('.c-main').css('margin-top', '');
                $('.c-cover').css('min-height', '');
                $('.o-roll.o-roll--homepage').css('margin-bottom', '');
            } else {
                $('.c-main').css('margin-top', headerOffset);
                $('.c-cover').css('min-height', headerOffset);
                $('.o-roll.o-roll--homepage').css('margin-bottom', headerHeight - $('.o-roll.o-roll--homepage').height());
            }
        }
    }

    function onScroll () {
        // If we are on mobile, no need to do any calculation
        if (isMobile) {
            return;
        }
        // Get the scroll position
        scrollTop = $(window).scrollTop();

        // If we are on the homepage
        if (isHomepage) {
            // Check if the scroll is below the absolute position of the header
            if (scrollTop > headerOffset) {
                $headerEl.addClass('fixed');
            } else {
                $headerEl.removeClass('fixed');
            }
        }

        // If we are on project detail page
        if (isTransparentHeader) {
            if (scrollTop > mainContentOffset) {
                $('.c-site-header').addClass('c-site-header--plain');
            } else {
                $('.c-site-header').removeClass('c-site-header--plain');
            }
        }
    }

    return {
        init: init,
        onScroll: onScroll,
        onResize: onResize
    }
};

export default homepageHeader;
